import styled, { css } from "styled-components";
import { focusStyle } from "../../styles/utils/Accessibility.styles";
import { breakpoints } from "../../../../../shared-logic/themes/toyotaTheme";

export const Wrapper = styled.div`
    display: flex;
    position: relative;
    flex-direction: column;
    flex-grow: 1;
`;

export const Bottom = styled.div`
    position: sticky;
    bottom: var(--spacing-4);
    margin-top: auto;
    background-color: var(--color-primary-white);
    z-index: 10;
`;

export const Top = styled.div`
    display: flex;
    position: sticky;
    top: var(--visibleHeaderHeight, 0);
    flex-direction: column;
    flex-grow: 0;
    row-gap: var(--spacing-2);
    padding-bottom: var(--spacing-7);

    @media screen and (min-width: ${breakpoints.xl}) {
        row-gap: var(--spacing-3);
        padding-block-start: var(--spacing-4);
    }

    @supports not (padding-block: 0) {
        top: 0;
        padding-top: var(--spacing-4);

        & > div:not(:nth-last-child(1)) {
            margin-bottom: var(--spacing-4);
        }
    }
`;

export const VehicleInformationDesktopWrapper = styled.div`
    display: none;
    @media screen and (min-width: ${breakpoints.md}) {
        display: block;
    }
`;

export const ButtonWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    column-gap: var(--spacing-2);
    margin-top: auto;
`;

export const Button = styled.button<{ iconRight?: boolean }>`
    display: flex;
    flex: 1 0 50%;
    align-items: center;
    justify-content: center;
    column-gap: var(--spacing-1);
    padding: var(--spacing-1);
    font-family: var(--font-regular);
    font-size: 1.3rem;
    line-height: 2rem;
    color: var(--color-primary-black);
    border: 1px solid var(--color-grey-4);
    border-radius: 3px;

    span:not(.dxp-icon) {
        flex-grow: 1;
    }

    ${({ iconRight }) =>
        iconRight &&
        css`
            flex-direction: row-reverse;
        `};

    &:is(:hover, :focus) {
        border-color: var(--color-primary-black);
    }

    &[disabled] {
        color: var(--color-grey-7);
        border-color: var(--color-grey-4);
    }

    ${focusStyle};
`;

export const InlineTextIcon = styled.div`
    display: flex;
    align-items: center;
    column-gap: var(--spacing-1);
`;

export const QrCodewrapper = styled.div`
    margin-top: var(--spacing-1);
`;
